/*
 * @Description: 
 */
/*
 * @Description: 
 */
import Util from './js/util.js'
import SystemDemo from './js/systemdemo.js'
import TuShi from './js/tushi.js'
import TiXi from './js/tixi.js'
import taskpane from './js/taskpane.js'
import { getFromLocal } from '@/utils/localStorageUtil.js'

//这个函数在整个wps加载项中是第一个执行的
function OnAddinLoad (ribbonUI) {
  if (typeof window.Application.ribbonUI != 'object') {
    window.Application.ribbonUI = ribbonUI
  }

  if (typeof window.Application.Enum != 'object') {
    // 如果没有内置枚举值
    window.Application.Enum = Util.WPS_Enum
  }

  window.showAiChat = SystemDemo.InvokeFromSystemDemo
  return true
}

function OnAction (control) {
  const eleId = control.Id
  switch (eleId) {
    case 'tushiLiuxiang':
      {
        const doc = window.Application.ActiveSheet
        if (!doc) {
          alert('当前没有打开任何表格')
          return
        }
        var tables = window.Application.Selection
        if (tables.Rows.Count > 1000) {
          alert('表格行数选中超过1000行，请检查')
        } else {
          TuShi.ParaseLiuxiangTu(tables)
          console.log('执行完毕')
          window.Application.ShowDialog(
            Util.GetUrlPath() + Util.GetRouterHash() + '/tsFlow',
            '流向图',
            1280 * window.devicePixelRatio,

            1000 * window.devicePixelRatio,
            true
          )
        }

      }
      break
    case 'tixiTu':
      {
        const sheet = window.Application.ActiveSheet
        if (!sheet) {
          alert('当前没有打开任何表格')
          return
        }
        console.log("tixiTu", sheet)
        var tables = window.Application.Selection
        console.log(tables.Rows.Count)
        if (tables.Rows.Count > 1000) {
          alert('表格行数选中超过1000行，请检查')
        } else {
          TiXi.Paresetixitu(tables)
          window.Application.ShowDialog(
            Util.GetUrlPath() + Util.GetRouterHash() + '/txFlow',
            '体系图',
            1280 * window.devicePixelRatio,
            1000 * window.devicePixelRatio,
            true
          )
        }
      }
      break
    case 'aiChat':
      {
        let tsId = window.Application.PluginStorage.getItem('taskpane_id')
        if (tsId) {
          let tskpane = window.Application.GetTaskPane(tsId)
          if (tskpane) {
            console.log("tskpane", tskpane)
            tskpane.Visible = !tskpane.Visible
            return
          }
        }
        let tskpane = window.Application.CreateTaskPane(Util.GetUrlPath() + Util.GetRouterHash() + '/aiChat')
        let id = tskpane.ID
        window.Application.PluginStorage.setItem('taskpane_id', id)
        tskpane.Visible = true
      }
      break
    case 'flowTest':
      window.Application.ShowDialog(
        Util.GetUrlPath() + Util.GetRouterHash() + '/flowTest',
        '流向图测试',
        1280 * window.devicePixelRatio,
        1000 * window.devicePixelRatio,
        true
      )
      break
    case 'setting':
      window.Application.ShowDialog(
        Util.GetUrlPath() + Util.GetRouterHash() + '/setting',
        '设置',
        1280 * window.devicePixelRatio,
        1000 * window.devicePixelRatio,
        true
      )
      break
    case 'login':
      window.Application.ShowDialog(
        Util.GetUrlPath() + Util.GetRouterHash() + '/login',
        '登录',
        600 * window.devicePixelRatio,
        400 * window.devicePixelRatio,
        true
      )
      break
    default:
      break
  }
  return true
}

function GetImage (control) {
  const eleId = control.Id
  switch (eleId) {
    case 'tushiLiuxiang':
      return 'images/liuxiang.svg'
    case 'tixiTu':
      return 'images/tixi.svg'
    case 'aiChat':
      return 'images/3.png'
    case 'setting':
      return 'images/setting.svg'
    case 'flowTest':
      return 'images/draw.svg'
    case 'login':
      return 'images/login.svg'
    default:
  }
  return 'images/newFromTemp.svg'
}
function OnGetEnabled (control) {
  const eleId = control.Id
  switch (eleId) {
    case 'tushiLiuxiang':
      return true
    case 'tixiTu':
      return true
    case 'flowTest':
      return true
    default:
      return getFromLocal('accessToken') != undefined
  }
}

function OnGetVisible (control) {
  const eleId = control.Id
  return getFromLocal('accessToken') == undefined
}


function OnNewDocumentApiEvent (doc) {
  alert('新建文件事件响应，取文件名: ' + doc.Name)
}

//这些函数是给wps客户端调用的
export default {
  OnAddinLoad,
  OnAction,
  GetImage,
  OnNewDocumentApiEvent,
  OnGetEnabled,
  OnGetVisible
}
